import React, { useEffect, useState } from 'react'
import './voice.css'
import Voice from './Voice'
import Header from '../../Components/Header/Header'
import ConfirmationBox from '../../Components/Confirmation/ConfirmationBox'
import axios from 'axios'
import { useAuthContext } from '../../hooks/UseAuthContext'
import { toast } from 'react-toastify'
import api from '../../api'
import Loader from '../../Components/Loader/Loader'
import GetChannel from '../Channels/GetChannel'
function Background() {
    const voices = [
    'The Headlines',
  'A Beautiful Thing',
  'A Long Life',
  'Alone Tonight',
  'Analog Input',
  'Attitude',
  'Bedtime Stories',
  'Blue Vision',
  'Bobby Astro',
  'Breathe It Out',
  'Dream Avenue',
  'Easy Day',
  'French Morning',
  'Get Back',
  'Grasshopper',
  "Its All Right",
  'Lullaby',
  'Magic Street',
  'Mellow',
  'Memories',
  'Midnight Trip',
  "Moments Notice",
  'Moody Blue',
  'Moving On',
  'New Arcade',
  'Pistachios',
  'Reflections',
  'So Close',
  'Southbound',
  'Spring',
  'Step',
  'Sunsets',
  'Sweet And Deep',
  'The Deep',
  'Trinity'
    ];
    const [activeVoice,setActiveVoice]=useState('')
    const [temporal,setTemporal]=useState(false)
    const [voice,setVoice]=useState(null)
    const {user}=useAuthContext()
    const [loading,setLoading]=useState(true)
    const [channelData,setChannelData]=useState(null)
    const [chooseChannel,setChooseChannel]=useState(false)

    useEffect(()=>{
      api.get(`/get-user`,{
        headers:{
          Authorization:`Bearer ${user.token}`
        }
      }).then(response=>{
        console.log(response.data)
        if(response.data?.background){
          setActiveVoice(response.data.background)
        }
        setLoading(false)
      }).catch(error=>{
        console.log(error)
        setLoading(false)
      })

    },[])
    useEffect(()=>{
        setActiveVoice(channelData?.background_music)
    },[channelData])
    const handleConfirm=(value)=>{

      if(value==true){
      
        setTemporal(false)
        api.post(`/channel/update-audio`,{
          music:voice,
          channelId:channelData._id,
      

        },{
          headers:{
            Authorization:`Bearer ${user.token}`
          }
        }).then(response=>{
          console.log(response.data)
       
            setActiveVoice(response.data.voice)
            toast.success(`is now active voice`)
          
        }).catch(error=>{
          toast.error("Error")
          console.log(error)
        })
      }else{
        setTemporal(false)
      }

    }
  return (
    <div className='voices-container'>
      <Header/>
        <div className="voices">
            <h2>Voices</h2>
            <p>Select the Best Available Background Music that fits your niche</p>

            <div className="ai-voices">
                {
                    voices.map((voice,index)=>(
                    <div className='singles-voice'>
                     <div className="voice-name">
                        <h3>{index+1}.) {voice}</h3>
                        <div class="checkbox-wrapper-31">
  <input type="checkbox" checked={activeVoice==voice} onClick={()=>{
   if(channelData?.voice!=voice){
      setVoice(voice)
      setChooseChannel(true)
    }
    
  }}/>
  <svg viewBox="0 0 35.6 35.6">
    <circle class="background" cx="17.8" cy="17.8" r="17.8"></circle>
    <circle class="stroke" cx="17.8" cy="17.8" r="14.37"></circle>
    <polyline class="check" points="11.78 18.12 15.55 22.23 25.17 12.87"></polyline>
  </svg>
</div>
                     </div>
                     <div className="voice-record">
                           <Voice url={`${process.env.REACT_APP_MEDIA_URL}/background/${voice}.mp3`}/>

                           <div className="select-voice">
                           </div>
                     </div>
                    
                    </div>
                    ))

                }
            </div>
        </div>

      
        {
          temporal&&(
            <ConfirmationBox message={"Are you sure you want to select this voice"} handleConfirm={handleConfirm}/>
          )
        }

        {
        chooseChannel&&(
          <div className="composition-channel">
         <div className="get-channel">
           <GetChannel 
            setChannelData={setChannelData} />
          <div className='composition-channel-btns'>
            <button onClick={()=>{
            setChooseChannel(false)
            setTemporal(true)
            }}>Proceed</button>
          <button onClick={()=>{
            setChooseChannel(false)
          }}>Cancel</button>
          </div>
         </div>
        </div>
        )
      }
        
      {
        loading&&(
          <Loader />
        )
      }
    </div>
  )
}

export default Background
